import { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fmtPay = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// rows: [{ key, driver_id, load_rate, total_miles, status }] → { byKey, total, counted, loading }
export const usePayPreview = (rows, enabled = true) => {
  const [result, setResult] = useState({ byKey: {}, total: 0, counted: 0, loading: false });
  const timer = useRef(null);
  const sig = JSON.stringify(rows || []);

  useEffect(() => {
    if (!enabled || !rows || !rows.length) { setResult({ byKey: {}, total: 0, counted: 0, loading: false }); return undefined; }
    setResult((r) => ({ ...r, loading: true }));
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try {
        const res = await axios.post(`${API}/loads/import/pay-preview`, { rows }, { withCredentials: true });
        const byKey = {};
        (res.data.rows || []).forEach((r) => { byKey[r.key] = r; });
        setResult({ byKey, total: res.data.total_payroll_impact || 0, counted: res.data.loads_counted || 0, loading: false });
      } catch {
        setResult((r) => ({ ...r, loading: false }));
      }
    }, 400);
    return () => clearTimeout(timer.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sig, enabled]);

  return result;
};
